'use strict'

var convert = require('unist-util-is/convert')

var isPhrasing = convert([
  'break',
  'delete',
  'emphasis',
  'footnote',
  'footnoteReference',
  'image',
  'imageReference',
  'inlineCode',
  'link',
  'linkReference',
  'strong',
  'text'
])

isPhrasing.displayName = 'isPhrasing'
module.exports = isPhrasing
